import { actionTypesEnum } from '../enum';

export default (state = null, action) => {

    if(action.type === actionTypesEnum.getEmisor){
      return action.payload;
    }

     return state;
  }